import './styles.scss';
import React from 'react';
import { ChevronLeft, ChevronRight } from '@edx/paragon/icons';
import { Helmet } from 'react-helmet-async';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';
import getStructuredData from './structuredData';
import BreadcrumbsPropTypes from './propTypes';

function Breadcrumbs({ pageTitle, breadCrumbs, textColor }) {
  if (!pageTitle) {
    return null;
  }

  const textColorVariant = textColor === 'dark' ? 'breadcrumb-text-dark' : 'breadcrumb-text-white';
  const linkColorVariant = textColor === 'dark' ? 'breadcrumb-link-dark' : 'breadcrumb-link-white';
  const links = [{ label: 'Home', href: '/' }, ...breadCrumbs];

  return (
    <div className="page-title-breadcrumbs mb-4">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(getStructuredData(links))}
        </script>
      </Helmet>
      <ul id="breadcrumblist" className="p-0 m-0 d-inline-block clear-list ">
        {
          links.map((bread, i) => {
            if (i + 1 === links.length) {
              return (
                <li className="d-none d-sm-inline-block" key={bread.label}>
                  <ChevronRight aria-hidden="true" className={`d-inline-block ${textColorVariant}`} />
                  <span className={textColorVariant}>
                    {bread.label}
                  </span>
                </li>
              );
            }
            return (
              <li className="d-inline-block" key={bread.label}>
                {i === 0
                  ? <ChevronLeft aria-hidden="true" className={`d-sm-none ml-n2 ${textColorVariant}`} style={{ paddingBottom: '3px' }} />
                  : <ChevronRight aria-hidden="true" className={`d-inline-block ${textColorVariant}`} />}
                <ProspectusLink
                  href={bread.href}
                  className={`inline-link ${linkColorVariant} ${textColorVariant}`}
                  analytics={{
                    eventName: 'edx.bi.learn-page.learn-breadcrumb-link.clicked',
                  }}
                >
                  {bread.label}
                </ProspectusLink>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
}

Breadcrumbs.propTypes = BreadcrumbsPropTypes;

export default Breadcrumbs;
